export default class Search {
  constructor(params = {}) {
    this.slugs = params.slugs || [];
    this.urgency = params.urgency || 0;
    this.topics = params.topics || [];
    this.update = params.update || 0;
    this.uno = params.uno;
  }
}



// WEBPACK FOOTER //
// ./src/models/Search.js